// extracted by mini-css-extract-plugin
module.exports = {"moduleContent":"modulecontent_moduleContent__3a4pH"};